import { defineStyleConfig } from '@chakra-ui/system';

const mdSize = { height: 10, borderRadius: 'base' };

/**
 * Configuration for all input variations
 */
const _placeholder = {
    color: 'slt-black.600',
    textStyle: 'slt-body-text-lg',
};

const _hover = null;

/**
 * Input variations
 */
const filled = {
    // we use filled variant for
    // search input
    field: {
        backgroundColor: 'gray.50',
        _focusVisible: {
            backgroundColor: 'white',
        },
        _hover,
        _placeholder,
    },
};

const outline = {
    field: {
        borderColor: 'slt-black.900',
        color: 'slt-black.900',
        textStyle: 'slt-body-text',
        lineHeight: '1.625rem',
        fontSize: '1.125rem',
        _disabled: {
            backgroundColor: 'slt-black.50',
        },
        _invalid: {
            borderColor: 'slt-red-error',
        },
        _focusVisible: {
            borderColor: 'slt-black.900',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
        },
        _hover,
        _placeholder,
    },
};

const newStyle = {
    field: {
        textStyle: 'body-base',
        color: 'slt-pepper.1000',
        border: '1px solid',
        borderColor: 'slt-pepper.1000',
        borderRadius: 4,
        padding: 2,
        fontFamily: 'TT Norms Pro',
        _invalid: {
            borderColor: 'slt-red-error',
        },
        _placeholder: {
            fontFamily: 'TT Norms Pro',
            color: 'slt-pepper.600',
        },
    },
};

const sltSearch = {
    field: {
        textStyle: 'body-base',
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '1.5rem',
        color: 'slt-pepper.1000',
        borderRadius: 8,
        border: '1px solid',
        borderColor: 'slt-pepper.300',
        height: 'auto',
        paddingX: 4,
        paddingY: { base: 2, md: 3 },
        _placeholder: {
            color: 'slt-pepper.1000',
        },
        _focus: {
            boxShadow: 'none',
            borderColor: 'slt-pepper.300',
            _placeholder: {
                color: 'transparent',
            },
        },
    },
};

export const Input = defineStyleConfig({
    sizes: {
        md: {
            field: { ...mdSize, px: 3 },
            addon: mdSize,
        },
    },
    variants: {
        filled,
        outline,
        'new-style': newStyle,
        'slt-search': sltSearch,
    },
});
